import BaseModel from '../models/base-model';
import User from '../user/model';
import ActivityType from '../models/activity-type';
/**
 * format:
 * @COMMON_NAME: "Accenture UI Key User PIN"
 * @REL_ATTR: "400114"
 * @id: "400114"
 */
const ACTIVITY_ICON_TYPES = {
  DEFAULT: 'mdi-information-outline',
  INIT: 'mdi-file-document-outline',
  TR: 'mdi-source-branch',
  RECLA: 'mdi-help-circle-outline',
  LOG: 'mdi-comment-outline',
  SEG_USU: 'mdi-comment-outline',
  RS: 'mdi-magnify',
  CL: 'mdi-square-rounded-outline',
  CNCL: 'mdi-square-rounded-outline',
  ESC: 'mdi-swap-vertical-bold',
  ATTACHTDOC: 'mdi-paperclip',
  DETACHTDOC: 'mdi-trash-can-outline',
  RE: 'mdi-check-box-outline',
  RO: 'mdi-folder-open-outline',
  ST: 'mdi-twitter-retweet',
  APPROVED: 'mdi-check-circle-outline',
  ACT_PLANI: 'mdi-asterisk',
  RECLAMAR: 'mdi-asterisk',
  NF: 'mdi-asterisk',
  SRVY_VALUE: 'mdi-star-outline',
};

const HIDDEN_DESCRIPTION_TYPES = ['INIT'];

export default class Activity extends BaseModel {
  constructor(data = {}) {
    super(data);

    this.ticketId = data.call_req_id || null;
    this.date = data.time_stamp || null;

    this.analyst = null;
    if (data.analyst != null) {
      this.analyst = new User(data.analyst);
    }

    this.type = null;
    if (data.type != null) {
      this.type = new ActivityType(data.type);
    }

    this.icon = ACTIVITY_ICON_TYPES.DEFAULT;
    const typeCode = (this.type || {}).code;
    if (typeCode != null && ACTIVITY_ICON_TYPES[typeCode] != null) {
      this.icon = ACTIVITY_ICON_TYPES[typeCode];
    }

    this.description = null;
    if (typeCode != null && data.description != null
         && data.action_desc !== data.description
         && !HIDDEN_DESCRIPTION_TYPES.includes(typeCode)) {
      if (typeCode === 'DETACHTDOC') {
        this.description = data.description.replace(/Detach Document :/i, '');
      } else {
        this.description = data.description;
      }
    }

    this.actionDescription = null;
    if (typeCode != null && data.action_desc != null) {
      if (typeCode === 'ST') {
        // Status changed from 'Fijada' to 'Abierta'
        const from = data.action_desc.replace(/.*from\s*'(.*?)'\s*to\s*'(.*)?'.*/, '$1');
        const to = data.action_desc.replace(/.*from\s*'(.*?)'\s*to\s*'(.*)?'.*/, '$2');
        this.actionDescription = {
          from: from === 'Retrasada' ? 'Planificada' : from,
          to: to === 'Retrasada' ? 'Planificada' : to,
        };
      }
    }
  }
}
